import { handleResponse } from './handleresponse'
import { apiurl } from '@/services/config'
const API_URL = apiurl

export const TransactionServices = {
  getTrxBuy,
  getSumBuy
}

function getSumBuy () {
  return fetch(API_URL + '/api/v1/transactions/buyer/today', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getTrxBuy (opt) {
  var sort = 'id'
  var sorder = 'DESC'
  if (opt.sortBy) {
    sort = opt.sortBy[0]
    if (typeof sort === 'undefined') {
      sort = localStorage.getItem('sortbytrxbeli')
    } else {
      localStorage.setItem('sortbytrxbeli', sort)
    }
  }
  if (opt.sortDesc) {
    if (opt.sortDesc[0]) {
      sorder = 'DESC'
    } else {
      sorder = 'ASC'
    }
  }
  if (opt.itemsPerPage < 0) {
    opt.itemsPerPage = 10000
  }

  if (!opt.search) {
    opt.search = ''
  }
  if (typeof opt.statustrx === 'undefined' || opt.statustrx === null) {
    opt.statustrx = ''
  }
  if (typeof opt.sellerid === 'undefined' || opt.sellerid === null) {
    opt.sellerid = ''
  }
  const page = opt.page - 1
  const sorting = sort + ',' + sorder
  if (opt.categoryid === undefined || opt.categoryid === null) {
    opt.categoryid = ''
  }
  if (opt.brandid === undefined || opt.brandid === null) {
    opt.brandid = ''
  }
  return fetch(API_URL + '/api/v1/transactions/buyer?search=' + opt.search + '&brandid=' + opt.brandid + '&categoryid=' + opt.categoryid + '&statustrx=' + opt.statustrx + '&sellerid=' + opt.sellerid + '&awal=' + opt.awal + '&akhir=' + opt.akhir + '&page=' + page + '&size=' + opt.itemsPerPage + '&sort=' + sorting, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
